import React from "react"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { AuthProvider } from "./context/AuthContext"
import ProtectedRoute from "./components/ProtectedRoute"
import Login from "./pages/Login"
import Dashboard from "./pages/Dashboard"
import Users from "./pages/Users"
import Departments from "./pages/Departments"
import Permissions from "./pages/Permissions"
import Customers from "./pages/Customers"
import Services from "./pages/Services"
import Finances from "./pages/Finances"
import Tasks from "./pages/Tasks"
import Communications from "./pages/Communications"
import Notifications from "./pages/Notifications"
import Settings from "./pages/Settings"
import Profile from "./pages/Profile"
import Layout from "./components/Layout"

function App() {
  return React.createElement(
    AuthProvider,
    null,
    React.createElement(
      Router,
      null,
      React.createElement(
        Routes,
        null,
        React.createElement(Route, { path: "/login", element: React.createElement(Login) }),
        React.createElement(
          Route,
          { path: "/", element: React.createElement(ProtectedRoute, null, React.createElement(Layout)) },
          React.createElement(Route, { index: true, element: React.createElement(Dashboard) }),
          React.createElement(Route, { path: "users", element: React.createElement(Users) }),
          React.createElement(Route, { path: "departments", element: React.createElement(Departments) }),
          React.createElement(Route, { path: "permissions", element: React.createElement(Permissions) }),
          React.createElement(Route, { path: "customers", element: React.createElement(Customers) }),
          React.createElement(Route, { path: "services", element: React.createElement(Services) }),
          React.createElement(Route, { path: "finances", element: React.createElement(Finances) }),
          React.createElement(Route, { path: "tasks", element: React.createElement(Tasks) }),
          React.createElement(Route, { path: "communications", element: React.createElement(Communications) }),
          React.createElement(Route, { path: "notifications", element: React.createElement(Notifications) }),
          React.createElement(Route, { path: "settings", element: React.createElement(Settings) }),
          React.createElement(Route, { path: "profile", element: React.createElement(Profile) }),
        ),
        React.createElement(Route, { path: "*", element: React.createElement(Navigate, { to: "/" }) }),
      ),
    ),
  )
}

export default App
